<mat-toolbar class="universal-nav">
  <div class="nav-container">
    <!-- Left section - Pharmacy type tabs -->
    <div class="nav-left" *ngIf="hasDrugs && showPharmacyTypeTabs">
      <button mat-button [class.active]="activeTab === CostTab.RETAIL_COST" (click)="setActiveTab(CostTab.RETAIL_COST)" class="nav-tab">
        <mat-icon>location_on</mat-icon>
        <span>{{ retailCostText }}</span>
      </button>
      <button
        mat-button
        [class.active]="activeTab === CostTab.MAIL_ORDER_COST"
        (click)="setActiveTab(CostTab.MAIL_ORDER_COST)"
        class="nav-tab"
      >
        <mat-icon>local_shipping</mat-icon>
        <span>{{ mailOrderText }}</span>
      </button>
    </div>

    <!-- Right section - Actions -->
    <div class="nav-right">
      <ng-container *ngFor="let link of headerLinks; trackBy: trackByLinkTitle">
        <ng-container *ngIf="link.href; else showButton">
          <app-link
            [title]="link.title"
            [href]="link.href"
            [additionalIcon]="link.iconName"
            [linkTarget]="link.target"
            [noUnderlineOnHover]="true"
            [customClass]="'Spa_Style_Smaller_Font mat-mdc-button'"
            [iconClass]="'Spa_Style_Large_Font'"
            [role]="LinkRoles.LINK"
            (click)="onClickHeaderLink(link)"
          ></app-link>
        </ng-container>

        <ng-template #showButton>
          <button mat-button class="nav-action" [title]="link.tooltipText || ''" (click)="onClickHeaderLink(link)">
            <mat-icon *ngIf="link.iconName">{{ link.iconName }}</mat-icon>
            <span>{{ link.title }}</span>
          </button>
        </ng-template>
      </ng-container>
    </div>
  </div>
</mat-toolbar>
